var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal-card",
      staticStyle: { height: "90vh", width: "auto" },
    },
    [
      _c(
        "div",
        { staticClass: "modal-card-body" },
        [
          _c("b-loading", {
            model: {
              value: _vm.isLoading,
              callback: function ($$v) {
                _vm.isLoading = $$v
              },
              expression: "isLoading",
            },
          }),
          _c("div", { staticClass: "flex is-justify-content-space-between" }, [
            _c("div", { staticClass: "is-flex is-align-items-center" }, [
              _c("h1", [_vm._v(" " + _vm._s(_vm.viewingSi.ref))]),
              _c(
                "div",
                {
                  class: [
                    `has-background-${_vm.getColor(_vm.viewingSi)}`,
                    "px-3",
                    "py-1",
                    "ml-3",
                  ],
                },
                [_vm._v(" " + _vm._s(_vm.getStatus(_vm.viewingSi)) + " ")]
              ),
            ]),
            _c(
              "div",
              { staticClass: "is-flex is-align-items-center" },
              [
                _c("span", { staticClass: "mr-3" }, [_vm._v("Version:")]),
                _c(
                  "b-select",
                  {
                    attrs: { placeholder: "version" },
                    on: { input: _vm.handleVersionChange },
                    model: {
                      value: _vm.viewingSi,
                      callback: function ($$v) {
                        _vm.viewingSi = $$v
                      },
                      expression: "viewingSi",
                    },
                  },
                  _vm._l(_vm.shippingInstructions, function (data) {
                    return _c(
                      "option",
                      { key: data.id, domProps: { value: data } },
                      [_vm._v(" " + _vm._s(data.version) + " ")]
                    )
                  }),
                  0
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "columns is-multiline is-mobile" }, [
            _c(
              "div",
              { staticClass: "column is-half" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "SI Date" } },
                  [
                    _c("b-input", {
                      attrs: { value: _vm.viewingSi.createdAt },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column is-half" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "PO Number" } },
                  [
                    _c("b-input", {
                      attrs: { value: _vm.viewingSi.purchaseOrderNumber },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column is-full" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Bill of Landing" } },
                  [
                    _c("b-input", {
                      attrs: { value: _vm.viewingSi.billOfLading },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column is-half" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Invoice" } },
                  [_c("b-input", { attrs: { value: _vm.viewingSi.invoice } })],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column is-half" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "USD Rate" } },
                  [_c("b-input", { attrs: { value: _vm.viewingSi.usdRate } })],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column is-one-third" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Quantity" } },
                  [_c("b-input", { attrs: { value: _vm.viewingSi.quantity } })],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column is-one-third" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Material" } },
                  [_c("b-input", { attrs: { value: _vm.viewingSi.material } })],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column is-one-third" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "OB" } },
                  [_c("b-input", { attrs: { value: _vm.viewingSi.ob } })],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column is-one-third" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Departure Plant" } },
                  [
                    _c("b-input", {
                      attrs: { value: _vm.viewingSi.departurePlantId },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column is-one-third" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Loading Port" } },
                  [
                    _c("b-input", {
                      attrs: { value: _vm.viewingSi.loadingPortId },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column is-one-third" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "ETD" } },
                  [
                    _c("b-input", {
                      attrs: { value: _vm.viewingSi.estimatedTimeOfDeparture },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column is-one-third" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Arrival Port" } },
                  [
                    _c("b-input", {
                      attrs: { value: _vm.viewingSi.arrivalPortId },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column is-one-third" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Delivered At" } },
                  [
                    _c("b-input", {
                      attrs: { value: _vm.viewingSi.deliveredAt },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column is-one-third" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Delivered Qty" } },
                  [
                    _c("b-input", {
                      attrs: { value: _vm.viewingSi.deliveredQuantity },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column is-full" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Processor" } },
                  [
                    _c("b-input", {
                      attrs: {
                        value: `${_vm.viewingSi.processorId} - ${_vm.viewingSi.processorName} - ${_vm.viewingSi.processorConsignee}`,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column is-full" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Enduser" } },
                  [
                    _c("b-input", {
                      attrs: {
                        value: `${_vm.viewingSi.enduserId} - ${_vm.viewingSi.enduserName} - ${_vm.viewingSi.enduserConsignee}`,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }